module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /Users/sooweeseng/Documents/Ionic Apps/ShunFa/ShunFa-Restaurant Backend/Restaurant_Firebasebackend/webapp/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main